module.exports = __webpack_public_path__ + "img/rogue.8321ab91.png";